import axios from '../helpers/axios'
import { AxiosResponse } from 'axios';

export const turnOffFeatureFlag = (
  featureFlag: string,
  reason: string,
  pageUrl: string
): Promise<AxiosResponse<any>> => {
  return axios.put(`/api/user-features?featureFlag=${featureFlag}`, { reason, pageUrl });
};

export const getOptInFeatureFlagEnabled = async (featureFlag: string): Promise<boolean> => {
  try {
    const { data } = await axios.get(`/api/user-features/${featureFlag}/opt-in`);
    return data;
  } catch (error) {
    Promise.reject(error?.response?.data);
  }
};
